export default __webpack_public_path__ + "static/media/5-3.b9a052f7.jpg";